import AxiosInstance from '../axios.js';

class ItemRequest {
  getItems(params) {
    const url = '/items'
    return AxiosInstance.get(url, { params })
  }
}
export default new ItemRequest()
